/* eslint react-hooks/immutability: ["warn"] */
import { useCallback, useState } from "react";
import { useTranslation } from "@coworker/locales";
import ImageIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ImageIconPath";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";
import { AddImagesModal } from "@coworker/apprestructured/src/task-management/components/AddImagesModal/AddImagesModal";
import { FullWidthButton } from "../../SkapaButton";
import styled from "styled-components";

const CenterContainer = styled.div`
  flex-grow: 1;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 16px 0px;
`;

interface UploadImageButtonProps {
  existingImages: NewOrExistingFile[];
  onImagesChange: (images: NewOrExistingFile[]) => void;
}

export const UploadImageButton = ({
  existingImages,
  onImagesChange,
}: UploadImageButtonProps) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState<NewOrExistingFile[]>([]);

  const handleAddImagesButtonClick = useCallback(() => {
    setModalImages(existingImages);
    setIsModalOpen(true);
  }, [existingImages]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleAddImagesModalConfirmClick = useCallback(() => {
    onImagesChange(modalImages);
  }, [modalImages, onImagesChange]);

  return (
    <>
      <CenterContainer>
        <FullWidthButton
          size="medium"
          text={
            existingImages.length > 0
              ? `${t("addOrUpdateImagesString")} (${existingImages.length})`
              : t("addImagesString")
          }
          type="secondary"
          disabled={false}
          ssrIcon={ImageIconPath}
          onClick={handleAddImagesButtonClick}
        />
      </CenterContainer>
      <AddImagesModal
        isOpen={isModalOpen}
        images={modalImages}
        onImagesChange={setModalImages}
        onClose={handleCloseModal}
        onConfirmClick={handleAddImagesModalConfirmClick}
      />
    </>
  );
};
